/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { NewsletterRegistrationProps } from './NewsletterRegistration.component';
import { TagCommanderService } from 'features/tagCommander/business/TagCommander.service';
import { useTagPlan } from 'features/tagPlan/business/useTagPlan';
import React, { ComponentPropsWithRef, FC } from 'react';
import { SocialNetwork } from '@actus/types';
import { SquareSvgProps } from '@components/icons/icon.types';
import { Text } from '@components/Text/Text.component';
import { useClassNames } from '@styles/breakpoints';
import { Constants } from '@utils/Constants';
import classnames from 'classnames';
import { ATLevel2 } from 'features/tagPlan/business/TagPlan.types';
import dynamic from 'next/dynamic';
import styles from './Footer.module.scss';

const NewsletterRegistration = dynamic<NewsletterRegistrationProps>(
  () => import('./NewsletterRegistration.component').then((mod) => mod.NewsletterRegistration),
  { ssr: false }
);

const FacebookLogoIcon = dynamic<SquareSvgProps>(
  () => import('@components/icons/social/FacebookLogo.icon').then((mod) => mod.FacebookLogoIcon),
  { ssr: false }
);
const LinkedinLogoIcon = dynamic<SquareSvgProps>(
  () => import('@components/icons/social/LinkedinLogo.icon').then((mod) => mod.LinkedinLogoIcon),
  { ssr: false }
);
const XLogoIcon = dynamic<SquareSvgProps>(
  () => import('@components/icons/social/XLogo.icon').then((mod) => mod.XLogoIcon),
  { ssr: false }
);
const YoutubeLogoIcon = dynamic<SquareSvgProps>(
  () => import('@components/icons/social/YoutubeLogo.icon').then((mod) => mod.YoutubeLogoIcon),
  { ssr: false }
);
const TikTokLogoIcon = dynamic<SquareSvgProps>(
  () => import('@components/icons/social/TikTokLogo.icon').then((mod) => mod.TikTokLogoIcon),
  { ssr: false }
);

const FooterTop: FC<ComponentPropsWithRef<'div'>> = ({ className, ...rest }) => {
  const { tagClick } = useTagPlan();

  function handleTagClick(network: SocialNetwork, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    tagClick({ level2: ATLevel2.Footer, tagPageNameI18nArray: [{ code: network, notI18n: true }] });
    TagCommanderService.triggerEvent('click', event.currentTarget, {
      button_name: network,
    });
  }

  const rootClassName = classnames(styles['plc-footer-top'], className);
  const wrapperClassName = useClassNames({
    all: ['wrapper-s', 'plc-py-basis', 'flex', 'column', 'wrap'],
    s: ['plc-py-l'],
  });
  const socialBarClassName = useClassNames({ all: [styles['plc-footer-social-bar'], 'flex', 'justify-start'] });

  return (
    <div className={rootClassName} {...rest}>
      <div className={wrapperClassName}>
        <div>
          <NewsletterRegistration />
        </div>
        <div>
          <Text className="plc-mb-m plc-mb-up-s-basis" i18nKey="common.footer.follow-us" tag="div" variant="h4" />
          <div className={socialBarClassName}>
            <a
              className="plc-mr-s"
              href={Constants.SOCIAL.FACEBOOK_URL}
              onClick={(event) => handleTagClick(SocialNetwork.Facebook, event)}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FacebookLogoIcon size={40} title="" />
            </a>
            <a
              className="plc-mr-s"
              href={Constants.SOCIAL.LINKEDIN_URL}
              onClick={(event) => handleTagClick(SocialNetwork.Linkedin, event)}
              rel="noopener noreferrer"
              target="_blank"
            >
              <LinkedinLogoIcon size={40} title="" />
            </a>
            <a
              className="plc-mr-s"
              href={Constants.SOCIAL.X_URL}
              onClick={(event) => handleTagClick(SocialNetwork.X, event)}
              rel="noopener noreferrer"
              target="_blank"
            >
              <XLogoIcon size={40} title="" />
            </a>
            <a
              className="plc-mr-s"
              href={Constants.SOCIAL.YOUTUBE_URL}
              onClick={(event) => handleTagClick(SocialNetwork.Youtube, event)}
              rel="noopener noreferrer"
              target="_blank"
            >
              <YoutubeLogoIcon size={40} title="" />
            </a>
            <a
              href={Constants.SOCIAL.TIKTOK_URL}
              onClick={(event) => handleTagClick(SocialNetwork.TikTok, event)}
              rel="noopener noreferrer"
              target="_blank"
            >
              <TikTokLogoIcon size={40} title="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterTop;
